<template>
    <v-card class="p-3">
        <h5>Campagnes en cours
        <span v-if="campaigns.length">({{campaigns.length}})</span>
        </h5>
        <v-simple-table fixed-header v-if="campaigns.length">
            <thead>
                <tr>
                    <th class="text-left">Nom</th>
                    <th class="text-left">Type</th>
                    <th class="text-left">Statut</th>
                    <th class="text-left">Formulaire</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="campaign in campaigns" :key="campaign.id">
                    <td>
                        <a @click="redirectCampaign(campaign)">
                            {{ campaign.name }}
                        </a>
                    </td>
                    <td>{{ campaign.type === 'CMAJ'? 'Mise à jour' : 'Partenariat' }}
                        <span v-if="campaign.type === 'CMAJ' && campaign.aspect !== null">
                            {{getAspectIcon(campaign)}}
                        </span>
                    </td>
                    <td>{{ campaign.state.label }}</td>
                    <td>{{ campaign.form_state }}</td>
                </tr>
            </tbody>
        </v-simple-table>
        <div class="text-center" v-if="campaigns.length === 0">
            <small>
                Aucune campagne
            </small>
        </div>
    </v-card>
</template>

<script>
export default {
    name: "CampaignBloc",
    props: ['providerId'],
    data() {
        return {
            campaigns: []
        }
    },
    methods: {
        redirectCampaign(campaign) {
            let type = campaign.type === 'CMAJ' ? 'cmaj' : 'cadh'

            this.$router.push('/campaign/' + type + '/' + this.encodeUri(campaign.id))
        },
        encodeUri(id) {
            return btoa(id)
        },
        getCampaigns() {
            this.$http.get('auth/providers/' + this.providerId + '/campaigns').then(res => {
                this.campaigns = res.body.data.campaigns
            })
        },
        getAspectIcon(campaign) {
                if(campaign.aspect === 'business') {
                    return '💼'
                } else if(campaign.aspect === 'summer') {
                    return '🔆'
                } else if(campaign.aspect === 'winter') {
                    return '❄️'
                }
        }
    },
    created() {
        this.getCampaigns()
    }
}
</script>